import React from 'react';

import { ButtonContentfulModel } from '../../api/models/Button';
import LinkBranded from '../../elements/links/Link.branded';
import LinkPro from 'src/elements/links/Link.pro';
import Heading from '../../elements/typography/heading';
import { CallToActionContainer } from './callToAction.styles';
import { LayoutTheme } from 'src/elements/layout/layout';
import CallToActionConfetti from 'src/molecules/callToAction/callToAction.confetti'
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';

export interface CallForActionProps {
  title: string;
  actionButton: ButtonContentfulModel;
  theme?: LayoutTheme;
}

const CallForAction = ({ actionButton, title, theme }: CallForActionProps): JSX.Element => {
  const CtaLink = theme === 'pro' ? LinkPro : LinkBranded;
  return (
    <FadeInAnimationWrapper>
      <CallToActionContainer theme={theme}>
        <CallToActionConfetti />
        <Heading text={title}
          size="2.785em"
          sizeMd="2.15em"
          sizeSm="1.875em"
          align="center" />
        <CtaLink
          text={actionButton.text}
          weight="normal"
          justify="center"
          url={actionButton.url}
          caption={actionButton.helpText}
          captionJustify="center"
        />
      </CallToActionContainer>
    </FadeInAnimationWrapper>
  )
}

export default CallForAction;
